import React, { useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import { Box, Button, Dialog, DialogActions, DialogContent, Grid, IconButton } from '@mui/material';
import { VisibilityOutlined } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import { useSnackbar } from 'notistack';
import { audits } from '../../../redux/api/userMgt';
import { Form, Formik } from 'formik';
import TextInput from '../../../components/common/TextInput';

const Audits = () => {
    const [processing, setProcessing] = useState(false);
    const [actionModal, setActionModal] = useState(false);
    const [selectedAudit, setSelectedAudit] = useState({});
    const { enqueueSnackbar } = useSnackbar();
    const [records, setRecords] = useState([]);

    const columns = [
        {
            field: 'sn',
            headerName: 'S/N',
            width: 80,
            sortable: false,
            renderCell: (params) => {
                return <p style={{ margin: 'auto' }}>{(params?.api?.getRowIndex(params?.row?.id) || 0) + 1}</p>;
            },
        },
        {
            field: 'action',
            headerName: 'Quick Action',
            width: 120,
            sortable: false,
            renderCell: (params) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <IconButton
                            size="small"
                            color={'primary'}
                            onClick={() => {
                                setSelectedAudit(params?.row || null);
                                setActionModal(true);
                            }}
                            variant="outlined"
                            title={'View'}
                        >
                            <VisibilityOutlined />
                        </IconButton>
                    </div>
                );
            },
        },
        {
            field: 'accessedResource',
            headerName: 'Accessed Resource',
            width: 350,
        },
        { field: 'activityDetail', headerName: 'Activity Detail', width: 500 },
    ];

    const init = async () => {
        try {
            setProcessing(true);
            const res = await audits();
            setRecords(res?.resultObject || []);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <PageContainer pageTitle="Audit Trail" tagline="View all audit trails" processing={processing}>
            <Box>
                <div className="paper" style={{ height: 650, width: '100%', textAlign: 'center' }}>
                    <DataGrid
                        className={'center-first-column'}
                        rows={records}
                        getRowId={(row) => row.id}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        checkboxSelection={false}
                        disableSelectionOnClick
                        style={{ fontSize: '12px' }}
                    />
                </div>
            </Box>

            <Dialog open={Boolean(actionModal)} maxWidth="lg" PaperProps={{ style: { minWidth: '50vw' } }}>
                <Formik initialValues={{ ...selectedAudit }} enableReinitialize>
                    {({ isSubmitting, values }) => (
                        <Form>
                            <DialogContent>
                                <h4 className="mb-1">View Audit</h4>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextInput id="accessedResource" readOnly label="Accessed Resource" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="activityDetail" multiline readOnly minRows={2} label="Activity Detail" />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions className="pb-1 pr-1">
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        setSelectedAudit({});
                                        setActionModal(false);
                                    }}
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </PageContainer>
    );
};

export default Audits;
